import * as echarts from "echarts";
import { useEffect, useRef } from "react";
// import "./ReportTrend.scss";

const ReportActionItemsTag = ({
  countByTagsChartData = [],
  labels = {},
  chartHeight,
}) => {
  const el = useRef(null);

  useEffect(() => {
    const option = {
      title: {
        show: countByTagsChartData.length === 0,
        text: "No data available",
        left: "center",
        top: "30%",
        textStyle: { color: "grey", fontSize: 20 },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
      },
      legend: {
        show: true,
        type: "scroll",
        top: "top",
        data: countByTagsChartData.map((item) => item?.name ?? ""),
        textStyle: { fontSize: 12, color: "#333" },
        itemWidth: 10,
        itemHeight: 10,
        itemGap: 10,
      },
      grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
      xAxis: {
        type: "category",
        data: [""],
        axisLabel: {
          formatter: (value) => {
            const label = value || "";
            return label.length > 10 ? `${label.slice(0, 10)}...` : label;
          },
          fontSize: 12,
        },
      },
      yAxis: { type: "value", minInterval: 1 },
      series: countByTagsChartData.map((item) => ({
        name: item?.name ?? "",
        type: "bar",
        data: [item?.count ?? 0],
        itemStyle: { color: item?.color || "#C1C1C1" },
        label: { show: true, position: "top", fontSize: 12 },
      })),
    };

    const chart = echarts.init(el.current, null, {
      width: el.current.offsetWidth,
      height: chartHeight || 270,
    });
    chart.setOption(option);

    function handleResize() {
      chart.resize({
        width: el.current.offsetWidth,
        height: chartHeight || 270,
      });
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [el, labels, chartHeight, countByTagsChartData]);

  return (
    <div className="chart-container">
      <div className="w-100" ref={el} />
    </div>
  );
};

export default ReportActionItemsTag;
